(() => {
  if (window.impactFeaturedPurchasePanelLoaded) return;
  window.impactFeaturedPurchasePanelLoaded = true;

  function initialize(root) {
    if (root.dataset.purchasePanelInitialized) return;
    root.dataset.purchasePanelInitialized = 'true';
    const activeOptions = new WeakMap();
    const picker = root.querySelector('variant-picker');

    function syncPaymentTerms() {
      const input = root.querySelector('.product-form input[name="id"]');
      if (!input) return;
      root.querySelectorAll('[data-featured-payment-variant]').forEach(paymentInput => {
        const terms = paymentInput.form.querySelector('shopify-payment-terms');
        if (terms && terms.getAttribute('variant-id') !== input.value) terms.setAttribute('variant-id', input.value);
        if (paymentInput.value !== input.value) {
          paymentInput.setAttribute('value', input.value);
          paymentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function restoreUrlVariant() {
      if (!picker || !root.isConnected) return;
      const variantId = new URL(window.location.href).searchParams.get('variant');
      const variants = JSON.parse(picker.querySelector('[data-variant-picker-variants]').textContent);
      const variant = variants.find(item => String(item.id) === variantId);
      if (!variant) return;
      const groups = [...picker.querySelectorAll('[data-variant-picker-option-inputs]')];
      const inputs = groups.map((group, index) => [...group.querySelectorAll('input')].find(input => input.value === variant.options[index]));
      if (inputs.length !== variant.options.length || inputs.some(input => !input)) return;
      if (inputs.every(input => input.checked)) {
        syncPaymentTerms();
        return;
      }
      inputs.forEach(input => { input.checked = true; });
      inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
      syncPaymentTerms();
    }

    function ready() {
      customElements.whenDefined('variant-picker').then(() => {
        requestAnimationFrame(restoreUrlVariant);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
    else ready();
    window.addEventListener('popstate', restoreUrlVariant);
    root.addEventListener('change', syncPaymentTerms);

    function controls() {
      return [...root.querySelectorAll('dropdown-opener[data-float-element-id]')].map(opener => {
        const menu = document.getElementById(opener.getAttribute('data-float-element-id'));
        if (!menu || !root.contains(menu)) return null;
        const labels = [...menu.querySelectorAll('label[for]')];
        return { opener, menu, labels };
      }).filter(Boolean);
    }

    function decorate() {
      controls().forEach(({ opener, menu, labels }) => {
        opener.setAttribute('tabindex', '0');
        opener.setAttribute('role', 'combobox');
        opener.setAttribute('aria-haspopup', 'listbox');
        opener.setAttribute('aria-autocomplete', 'none');
        opener.querySelectorAll('img').forEach(image => image.setAttribute('alt', ''));
        menu.setAttribute('role', 'listbox');
        const name = opener.parentElement.querySelector('.product-variant-picker__option-label');
        if (name) menu.setAttribute('aria-label', name.textContent.trim());
        const optionName = opener.parentElement.getAttribute('option-picker-name');
        if (optionName) opener.setAttribute('aria-label', optionName);
        const value = opener.querySelector('[data-dropdown-variant-picker-label]');
        if (value) {
          value.id = `${menu.id}-selected-value`;
          opener.setAttribute('aria-describedby', value.id);
        }
        labels.forEach((label, index) => {
          const radio = document.getElementById(label.htmlFor);
          label.setAttribute('role', 'option');
          label.setAttribute('tabindex', '-1');
          label.id = `${menu.id}-option-${index}`;
          label.setAttribute('aria-selected', String(Boolean(radio && radio.checked)));
          label.setAttribute('aria-label', label.textContent.trim().replace(/\s+/g, ' '));
          label.querySelectorAll('img').forEach(image => image.setAttribute('alt', ''));
        });
        if (opener.getAttribute('aria-expanded') !== 'true') {
          activeOptions.delete(opener);
          opener.removeAttribute('aria-activedescendant');
          labels.forEach(label => label.removeAttribute('data-keyboard-active'));
        }
      });
    }

    root.addEventListener('keydown', event => {
      const control = controls().find(({ opener, menu }) => opener.contains(event.target) || menu.contains(event.target));
      if (!control) return;
      const { opener, menu } = control;
      let labels = control.labels;
      const isOpener = opener.contains(event.target);
      const current = labels.findIndex(label => label.contains(event.target));
      const selected = Math.max(0, labels.findIndex(label => document.getElementById(label.htmlFor)?.checked));
      const open = opener.getAttribute('aria-expanded') === 'true';
      const keys = ['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'Escape'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (event.key === 'Escape') {
        if (open) opener.click();
        opener.focus();
        opener.removeAttribute('aria-activedescendant');
        labels.forEach(label => label.removeAttribute('data-keyboard-active'));
      } else if (isOpener) {
        let active = activeOptions.get(opener) ?? selected;
        if (!open) {
          opener.click();
          decorate();
          labels = [...menu.querySelectorAll('label[for]')];
          if (!labels.length) return;
          active = Math.max(0, labels.findIndex(label => document.getElementById(label.htmlFor)?.checked));
        } else if (event.key === 'Enter' || event.key === ' ') {
          labels[active].click();
          if (opener.getAttribute('aria-expanded') === 'true') opener.click();
          opener.focus();
          opener.removeAttribute('aria-activedescendant');
          decorate();
          return;
        } else if (event.key === 'ArrowDown') active = (active + 1) % labels.length;
        else if (event.key === 'ArrowUp') active = (active - 1 + labels.length) % labels.length;
        if (event.key === 'Home') active = 0;
        if (event.key === 'End') active = labels.length - 1;
        activeOptions.set(opener, active);
        opener.setAttribute('aria-activedescendant', labels[active].id);
        labels.forEach((label, index) => label.toggleAttribute('data-keyboard-active', index === active));
        labels[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' || event.key === ' ') {
        labels[current].click();
        if (opener.getAttribute('aria-expanded') === 'true') opener.click();
        opener.focus();
        decorate();
      } else {
        let next = current;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = labels.length - 1;
        if (event.key === 'ArrowDown') next = (current + 1) % labels.length;
        if (event.key === 'ArrowUp') next = (current - 1 + labels.length) % labels.length;
        labels[next].focus();
      }
    }, true);
    root.addEventListener('keyup', event => {
      const control = controls().find(({ opener, menu }) => opener.contains(event.target) || menu.contains(event.target));
      if (control && ['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'Escape'].includes(event.key)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    root.addEventListener('change', decorate);
    const observer = new MutationObserver(decorate);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-controls', 'aria-expanded'] });
    decorate();
    function handleUnload(event) {
      if (event.target.contains(root)) {
        observer.disconnect();
        window.removeEventListener('popstate', restoreUrlVariant);
        document.removeEventListener('DOMContentLoaded', ready);
        document.removeEventListener('shopify:section:unload', handleUnload);
      }
    }
    document.addEventListener('shopify:section:unload', handleUnload);
  }

  function initializeAll() {
    document.querySelectorAll('[data-featured-purchase-panel]').forEach(initialize);
  }
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
